import { Component, Input } from '@angular/core';

import { MainComponent } from '../../../evaluation-result/component/main/main.component';
import { CaEvaluationComponent } from '../../ca-evaluation.component';

@Component({
    selector: 'cmps-ca-analysis-dialog-toolbar',
    templateUrl: './toolbar.component.html',
})
export class ToolbarComponent {
    @Input() evalRef: CaEvaluationComponent | MainComponent;
    @Input() background: 'dark' | 'light';
    @Input() withProTips: boolean;
}
